import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ga82k8tpg: FaireProductEntity = {
  token: "p_6ga82k8tpg",
  type: "product",
  name: "New Shell Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4fa311887e9d659f693c762bc027e8fc646606ae249c6edadfaa84b544e624eb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3fd732ad0d606fb9520a9b3264c95181dae8f328b3f9e447caab48e6dd5df27a.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:00.012Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
